import styled from 'styled-components';

export const Container = styled.form`
	width: 100%;
`;

export const FolderList = styled.div`
	width: 100%;
	max-height: 212px;
	overflow-y: auto;
	padding: 10px 24px 15px 24px;

	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(90px, 1fr));
	gap: 10px;
`;

export const FolderItem = styled.label<{ isChecked: boolean }>`
	padding: 0 4px;
	height: 36px;
	box-sizing: content-box;

	border-radius: 6px;
	/* border: 1px solid ${({ theme }) => theme['warmgray-300']}; */
	border: 1px solid rgba(210, 200, 195, 0.6);

	background-color: ${({ theme, isChecked }) =>
		isChecked ? theme['orange-secondary'] : theme.white};

	display: flex;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;
`;
